var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLikeFilledSvg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "5 6 23 19.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2423_9156",
    x1: 3,
    y1: 9.00001,
    x2: 30.0325,
    y2: 10.5095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA905C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33187,
    stopColor: "#FFD29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472229,
    stopColor: "#FFE0B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.612142,
    stopColor: "#FFD29B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#BA905C"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.1645 8.74105L16.5 9.04471L16.8355 8.74105C17.7785 7.88755 19.6586 6.5 21.8393 6.5C24.9554 6.5 27.5 9.06484 27.5 12.229C27.5 13.1637 27.0732 14.0932 26.5982 14.8292C26.129 15.5563 25.6496 16.0382 25.6206 16.0673L25.6189 16.0691L16.5 25.289L7.37621 16.0641L7.37622 16.0641L7.37434 16.0622C7.34804 16.0359 6.86991 15.5552 6.40126 14.8287C5.92685 14.0932 5.5 13.1637 5.5 12.229C5.5 9.06484 8.04461 6.5 11.1607 6.5C13.3414 6.5 15.2215 7.88755 16.1645 8.74105Z",
    fill: "url(#paint0_linear_2423_9156)",
    stroke: "url(#paint0_linear_2423_9156)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeFilledSvg);
export default __webpack_public_path__ + "static/media/LikeFilledSVG.6dd6bbb1cb9da0bfaf8ad1727ca2826b.svg";
export { ForwardRef as ReactComponent };